/**
 * Workspace service (MI-268) — bridges the WorkspaceContext with the
 * module-level axios interceptor.
 *
 * Pattern mirrors tokenService.js: WorkspaceProvider registers a getter at
 * mount; the interceptor reads it on every outgoing request to attach the
 * X-Workspace-Id header.
 */

let _getWorkspaceId = null;

/** Register the workspace-id getter (called from WorkspaceProvider). */
export function setWorkspaceIdGetter(fn) {
  _getWorkspaceId = fn;
}

/** Return the current workspace id.
 *
 * Resolution order:
 *   1. The getter registered by WorkspaceProvider (live React state).
 *   2. localStorage fallback — for the brief window between the first API
 *      call and the WorkspaceProvider effect that registers the getter.
 *      Without this, requests fired during initial page render race the
 *      provider and the backend 422s on missing X-Workspace-Id.
 */
export function getWorkspaceId() {
  if (_getWorkspaceId) {
    try {
      const v = _getWorkspaceId();
      if (v) return v;
    } catch {
      // fall through to localStorage
    }
  }
  return readPersistedWorkspaceId();
}

const STORAGE_KEY = 'mikapital_active_workspace_id';

export function readPersistedWorkspaceId() {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  const n = Number(raw);
  return Number.isInteger(n) && n > 0 ? n : null;
}

export function persistWorkspaceId(id) {
  if (id) {
    localStorage.setItem(STORAGE_KEY, String(id));
  } else {
    localStorage.removeItem(STORAGE_KEY);
  }
}
